import React from "react";

const BorderIcon = ({
  side,
  border = "solid",
}: {
  side: "borderTop" | "borderLeft" | "borderRight" | "borderBottom" | "border";
  border?: "solid" | "dashed" | "dotted";
}) => {
  const getSolidLine = () => {
    switch (side) {
      case "borderTop":
        return "M0 0 H19";
      case "borderLeft":
        return "M0 0 V19";
      case "borderRight":
        return "M19 0 V19";
      case "borderBottom":
        return "M0 19 H19";
      case "border":
        return "";
      default:
        return "";
    }
  };

  const getStrokeDasharray = () => {
    switch (border) {
      case "dashed":
        return "4 2";
      case "dotted":
        return "1 1";
      default:
        return ""; // solid line
    }
  };

  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      {side === "border" ? (
        <rect
          x="0.5"
          y="0.5"
          width="18"
          height="18"
          stroke="black"
          strokeWidth="2"
          strokeDasharray={getStrokeDasharray()}
        />
      ) : (
        <>
          <rect
            x="0.967182"
            y="0.807392"
            width="17.2625"
            height="17.2625"
            stroke="black"
            strokeWidth="0.255409"
            strokeDasharray={getStrokeDasharray()}
          />
          <path d={getSolidLine()} stroke="black" strokeWidth="2" />
        </>
      )}
    </svg>
  );
};

export default BorderIcon;
